/** 消息连接只属于当前登录身份；换号、维护和卸载立即停止旧连接与重连。 */
export function createSessionSocket(options:{identity:()=>string;url:()=>string;connect:(url:string)=>WebSocket;message:(event:MessageEvent)=>void;changed:(socket:WebSocket|null)=>void;schedule?:(fn:()=>void,delay:number)=>any;cancel?:(id:any)=>void}){
  let identity='',generation=0,socket:WebSocket|null=null,timer:any,disposed=false
  const schedule=options.schedule || setTimeout,cancel=options.cancel || clearTimeout
  const close=()=>{generation++;if(timer!==undefined)cancel(timer);timer=undefined;const previous=socket;socket=null;options.changed(null);try{previous?.close()}catch(_){/* 关闭旧连接失败也不能恢复其身份。 */}}
  const retry=(run:number)=>{
    if(disposed || run!==generation || !identity || identity!==options.identity())return
    if(timer!==undefined)cancel(timer)
    timer=schedule(()=>{if(disposed || run!==generation || identity!==options.identity())return;timer=undefined;connect()},5000)
  }
  const connect=()=>{
    if(disposed || !identity || identity!==options.identity())return
    const run=++generation
    let current:WebSocket
    try{current=options.connect(options.url())}catch(_){socket=null;options.changed(null);retry(run);return}
    socket=current;options.changed(current)
    const active=()=>!disposed && run===generation && socket===current && identity===options.identity()
    current.addEventListener('message',event=>{if(active())options.message(event as MessageEvent)})
    current.addEventListener('close',()=>{if(!active())return;socket=null;options.changed(null);retry(run)})
    current.addEventListener('error',()=>{/* 由close事件安排有限身份范围内的重连。 */})
  }
  return {
    refresh(){const next=options.identity();if(disposed || next===identity)return;close();identity=next;if(identity)connect()},
    dispose(){disposed=true;identity='';close()}
  }
}
